import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './i18n';

import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import CaseDetail from './pages/CaseDetail';
import UserManagement from './pages/UserManagement';
import UserProfile from './pages/UserProfile';
import AdminSettings from './pages/AdminSettings';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* Legacy routes for backward compatibility */}
            <Route path="projects" element={<Projects />} />
            <Route path="projects/create" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            
            {/* New workspace/case hierarchy routes */}
            <Route path="workspaces" element={<Projects />} />
            <Route path="workspaces/create" element={<Projects />} />
            <Route path="workspaces/:id" element={<ProjectDetail />} />
            <Route path="workspaces/:workspaceId/cases/:caseId" element={<CaseDetail />} />
            
            <Route path="user-management" element={<UserManagement />} />
            <Route path="admin-settings" element={<AdminSettings />} />
            <Route path="profile" element={<UserProfile />} />
          </Route>
        </Routes>
      </Router>
      {/* Avisos efímers.
          `limit` és el que més es nota: abans se n'apilaven tants com accions
          feies i tapaven mitja pantalla. Amb dos alhora, i 2,5 segons, el que
          queda són els errors i les poques confirmacions que informen de coses
          que no es veuen enlloc més —una contrasenya generada, un correu
          enviat, uns factors que han anat a parar a una altra pestanya—.
          La resta es van treure: si afegeixes un factor i el factor apareix a
          la llista, l'avís no explica res que no estiguis veient. */}
      <ToastContainer
        position="top-right"
        autoClose={2500}
        limit={2}
        newestOnTop
        pauseOnFocusLoss={false}
      />
    </AuthProvider>
  );
}

export default App;